import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';

import { CompanyPlatformsListQuery, CompanyPlatformsListQueryVariables } from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { PlatformListProps, PlatformList } from '../components/platform_list';
import { companyPlatformsListQuery } from '../graphql';

class LoadingContainer extends Loader<
  CompanyPlatformsListQuery,
  PlatformListProps,
  CompanyPlatformsListQueryVariables
> {}

export const PlatformListContainer = () => {
  const { company_id } = useParams() as { company_id: string };

  const result = useQuery<CompanyPlatformsListQuery, CompanyPlatformsListQueryVariables>(companyPlatformsListQuery, {
    fetchPolicy: 'cache-and-network',
    variables: { company_id },
  });

  return (
    <LoadingContainer
      result={result}
      mapData={({ data }) => ({
        data: {
          platforms: data?.company?.platforms ?? [],
          company_id,
        },
      })}>
      {({ data }) => <PlatformList data={data} />}
    </LoadingContainer>
  );
};
